<div class="header">
  <h2>Pilot Employment Records</h2>
  <button mat-raised-button (click)="add()">
    <mat-icon>add</mat-icon> <span>Add Employment Record</span>
  </button>
  <button mat-raised-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<table
  mat-table
  *tdLoading="
    'pilot-employment-records-table';
    mode: 'indeterminate';
    type: 'circle';
    strategy: 'overlay';
    color: 'primary'
  "
  [dataSource]="employmentRecords$"
  fxFlex="100"
  multiTemplateDataRows
>
  <ng-container matColumnDef="prdDateOfHire">
    <th mat-header-cell *matHeaderCellDef>PRD Date of Hire</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.prdDateOfHire | date: 'MM/dd/yyyy' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="completeDate">
    <th mat-header-cell *matHeaderCellDef>Complete Date</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.completeDate | date: 'MM/dd/yyyy' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="finalRecordsDate">
    <th mat-header-cell *matHeaderCellDef>Final Records Date</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.finalRecordsDate | date: 'MM/dd/yyyy' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="separationDate">
    <th mat-header-cell *matHeaderCellDef>Separation Date</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.separationDate | date: 'MM/dd/yyyy' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="separationType">
    <th mat-header-cell *matHeaderCellDef>Seperation Type</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ getSeparationTypeDescription(employmentRecord.separationType) }}
    </td>
  </ng-container>
  <ng-container matColumnDef="separationTypeDetail">
    <th mat-header-cell *matHeaderCellDef>Seperation Type Detail</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.separationTypeDetail }}
    </td>
  </ng-container>
  <ng-container matColumnDef="relevantDocuments">
    <th mat-header-cell *matHeaderCellDef>Relevant Documents</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.relevantDocuments ? 'Yes' : 'No' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="processingState">
    <th mat-header-cell *matHeaderCellDef>Processing State</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.processingState | humanize }}
    </td>
  </ng-container>
  <ng-container matColumnDef="processingError">
    <th mat-header-cell *matHeaderCellDef>Processing Error</th>
    <td mat-cell *matCellDef="let employmentRecord" class="prd-processing-error-text">
      {{ employmentRecord.processingError }}
    </td>
  </ng-container>
  <ng-container matColumnDef="lastProcessedDate">
    <th mat-header-cell *matHeaderCellDef>Last Processed Date</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ (employmentRecord.lastProcessedDate | date: 'MM/dd/yyyy HH:mm') || '--' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="prdSourceSystemId">
    <th mat-header-cell *matHeaderCellDef>PRD Source System Id</th>
    <td mat-cell *matCellDef="let employmentRecord">
      {{ employmentRecord.prdSourceSystemId }}
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let employmentRecord">
      <button mat-icon-button [matMenuTriggerFor]="employmentRecordActions">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #employmentRecordActions="matMenu">
        <a mat-menu-item (click)="edit(employmentRecord)"> <mat-icon>edit</mat-icon>Edit </a>
        <a mat-menu-item (click)="delete(employmentRecord.id)">
          <mat-icon>delete</mat-icon>Delete
        </a>
      </mat-menu>
    </td>
  </ng-container>
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
    <td mat-cell *matCellDef="let employmentRecord">
      <button
        mat-icon-button
        aria-label="expand row"
        (click)="changeExpandedRecord(employmentRecord); $event.stopPropagation()"
      >
        <mat-icon *ngIf="expandedEmploymentRecord !== employmentRecord"
          >keyboard_arrow_down</mat-icon
        >
        <mat-icon *ngIf="expandedEmploymentRecord === employmentRecord">keyboard_arrow_up</mat-icon>
      </button>
    </td>
  </ng-container>
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let employmentRecord"
      [attr.colspan]="displayedColumnsWithExpand.length"
    >
      <div
        class="employment-record-detail"
        [@detailExpand]="employmentRecord == expandedEmploymentRecord ? 'expanded' : 'collapsed'"
      >
        <ng-container *ngIf="employmentRecord === expandedEmploymentRecord">
          <fl-pilot-employment-record-assignment-to-duties-list
            fxFlex="90"
            [employmentRecordId]="employmentRecord.id"
          ></fl-pilot-employment-record-assignment-to-duties-list>
        </ng-container>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumnsWithExpand"></tr>
  <tr
    mat-row
    *matRowDef="let employmentRecord; columns: displayedColumnsWithExpand"
    class="employment-record-row"
    [class.expanded-row]="expandedEmploymentRecord === employmentRecord"
    (click)="changeExpandedRecord(employmentRecord); $event.stopPropagation()"
  ></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>
<mat-paginator
  (page)="onPage($event)"
  [length]="total$ | async"
  [pageSize]="defaultPageSize"
  [pageSizeOptions]="pageSizeOptions"
>
</mat-paginator>
